const prosCollectionComponentType = {
  PROS_CAROUSEL: 'ProsCarousel',
  PROS_CONTENT_CAROUSEL: 'ProsContentCarousel',
  PROS_CONTENT_COLLECTION: 'ProsContentCollection',
  PROS_DASHBOARD: 'ProsDashboard',
  PROS_GRID: 'ProsGrid',
  PROS_VERTICAL: 'ProsVertical',
  RVI_CAROUSEL: 'RviCarousel',
  PROS_FBT: 'ProsFbt',
  PROS_BEAUTY_REGIMEN: 'ProsBeautyRegimen',
};

export default prosCollectionComponentType;
